import { WeekOfTheYearKey } from 'classes/WeekOfTheYearKey'
import { Tooltip } from 'react-tooltip'
import moment from 'moment'

export default function KinesisEventListItem({ 
    kinesisEvent = null,
    OnEventItemClick = () => {},
    NavigateCalendarToSpecificWeek = () => {}
}) {

    if (kinesisEvent === null) return null

    return (
        <div 
            className='flex items-center gap-x-3 pr-4 relative bg-white border-b border-gray-200 overflow-hidden transition-all cursor-pointer'
            onClick={() => OnEventItemClick()}
        >
            <div>
                <div className='ml-4 w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center text-orange-400 text-sm 2xl:text-lg font-bold'>
                    {kinesisEvent.eventType === 'a-race' ? 'A' : ''}
                    {kinesisEvent.eventType === 'b-race' ? 'B' : ''}
                    {kinesisEvent.eventType === 'c-race' ? 'C' : ''}
                </div>
            </div>
            
            <div className='py-4 flex-grow'>
                <div className='flex items-center gap-x-2'>
                    <div className='text-xs 2xl:text-sm font-semibold'>
                        {kinesisEvent.name}
                    </div>
                </div>

                <div className='text-xxs 2xl:text-xs text-gray-500'>
                    {kinesisEvent.eventTerrain && 
                        <>
                            {kinesisEvent.eventTerrain === 'other' &&
                                <>
                                    {kinesisEvent.eventTerrainTextInput === 'default-event' ? 'Other' : kinesisEvent.eventTerrainTextInput}
                                </>
                            }

                            {kinesisEvent.eventTerrain !== 'other' &&
                                <>
                                    {kinesisEvent.eventTerrain.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </>
                            }
                        </>
                    } 
                    
                    {' '}

                    {kinesisEvent.eventDistance &&
                        <>
                            {kinesisEvent.eventDistance === 'other' && kinesisEvent.eventDistanceTextInput !== 'default-event' &&
                                <>
                                    {kinesisEvent.eventDistanceTextInput}
                                </>
                            }

                            {kinesisEvent.eventDistance !== 'other' &&
                                <>
                                    {kinesisEvent.eventDistance.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </>
                            }
                        </>
                    }
                </div>
            </div>

            <div
                className="relative h-10 w-14 shrink-0 origin-left scale-[0.62] p-1 sm:scale-[0.78] 2xl:scale-100 -mr-2 sm:-mr-1 2xl:mr-0"
                data-tooltip-id={`taper-tooltip-${kinesisEvent.id}`}
                data-tooltip-place="left"
                data-tooltip-position-strategy="fixed"
                data-tooltip-content={
                    kinesisEvent.eventType === 'a-race' ? '3 week program taper' : 
                    kinesisEvent.eventType === 'b-race' ? '2 week program taper' : 
                    kinesisEvent.eventType === 'c-race' ? '1 week program taper' : 
                    'Taper period'
                }
            >
                <svg 
                    viewBox="-0.5 -0.5 57 41" 
                    className="w-full h-full block"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <linearGradient id="orangeGradient" x1="0" y1="0" x2="56" y2="0" gradientUnits="userSpaceOnUse">
                            <stop offset="0%" stopColor="#ff8904" /> {/* bg-orange-400 */}
                            <stop offset="100%" stopColor="#ffd6a8" /> {/* bg-orange-200 */}
                        </linearGradient>
                    </defs>
                    <polygon 
                        points="0,0 0,40 56,40" 
                        fill="url(#orangeGradient)" 
                        stroke="#ff8904" // bg-orange-400
                        strokeWidth="1"
                        strokeLinejoin="round"
                        strokeLinecap="square"
                    />
                </svg>

                <div className='absolute bottom-1.5 left-2.5'>
                    <div className='text-white text-xs font-bold'>
                        {kinesisEvent.eventType === 'a-race' ? '3' : ''}
                        {kinesisEvent.eventType === 'b-race' ? '2' : ''}
                        {kinesisEvent.eventType === 'c-race' ? '1' : ''}
                    </div>
                </div>

                <Tooltip 
                    id={`taper-tooltip-${kinesisEvent.id}`}
                    place="left"
                    positionStrategy="fixed"
                    noArrow={false}
                    style={{ maxWidth: '150px', fontSize: '12px', whiteSpace: 'normal', wordWrap: 'break-word', zIndex: 9999 }}
                />
            </div>

            <div className="shrink-0">
                <div
                    className="flex h-10 w-10 origin-right cursor-pointer flex-col overflow-hidden rounded-md hover:bg-gray-50 scale-[0.62] sm:scale-[0.78] 2xl:scale-100 -ml-6 sm:-ml-4 2xl:ml-0"
                    onClick={(e) => {
                        e.stopPropagation()
                        const eventWeekOfTheYearKey = new WeekOfTheYearKey(moment(kinesisEvent.eventDate));
                        NavigateCalendarToSpecificWeek(eventWeekOfTheYearKey);
                    }}
                >
                    <div className='text-center text-xxs text-white font-bold border-b border-rose-400 bg-red-400'>
                        {moment(kinesisEvent.eventDate).format('MMM')}
                    </div>

                    <div className='flex-1 flex items-center justify-center bg-gray-100 text-center text-sm font-bold'>
                        {moment(kinesisEvent.eventDate).format('D')}
                    </div>
                </div>
            </div>
        </div>
    )
}